export default function <T>(
  item: string | null | undefined,
  enumType: { [s: string]: string },
): T[keyof T] | undefined {
  const values: Array<string> = Object.values(enumType);

  if (item && Object.values(values).includes(item)) {
    const returnVal: unknown = item;
    return returnVal as T[keyof T];
  }
  return;
}
